import {
  UPDATE_PROFILE,
  UPDATE_PROFILE_SUCCESS,
  UPDATE_PROFILE_ERROR,
  VIEW_PROFILE_SUCCESS,
  VIEW_PROFILE,
  VIEW_PROFILE_ERROR,
} from "./actionTypes";

const initialState = {
  updateProfileMsg: null,
  viewProfileData: null,
  updateProfileError: null,
  viewProfileError: null,
  loading: false,
  userDeleted: false,
};

const verifyAccount = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_PROFILE:
      state = {
        ...state,
        updateProfileMsg: null,
        loading: false,
      };
      break;
    case UPDATE_PROFILE_SUCCESS:
      state = {
        ...state,
        updateProfileMsg: action.payload,
        loading: true,
      };
      break;
    case UPDATE_PROFILE_ERROR:
      state = { ...state, updateProfileMsg: action.payload, loading: false };
      break;
    // get individual profile data
    case VIEW_PROFILE:
      state = {
        ...state,
        viewProfileData: null,
        loading: false,
      };
      break;
    case VIEW_PROFILE_SUCCESS:
      state = {
        ...state,
        viewProfileData: action.payload,
        loading: true,
      };
      break;
    case VIEW_PROFILE_ERROR:
      state = { ...state, viewProfileData: action.payload, loading: false };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default verifyAccount;
